export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";